/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "./utils";
import {
  Button,
  Divider,
  Flex,
  Heading,
  Text,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
export default function FoodDiaryCard(props) {
  const { overrides, ...rest } = props;
  return (
    <Flex
      gap="0"
      direction="row"
      width="unset"
      height="unset"
      justifyContent="flex-start"
      alignItems="flex-start"
      position="relative"
      padding="0px 0px 0px 0px"
      {...getOverrideProps(overrides, "FoodDiaryCard")}
      {...rest}
    >
      <Flex
        gap="24px"
        direction="column"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-start"
        shrink="0"
        position="relative"
        padding="32px 32px 32px 32px"
        backgroundColor="rgba(255,255,255,1)"
        {...getOverrideProps(overrides, "Card Area")}
      >
        <Heading
          width="unset"
          height="unset"
          shrink="0"
          alignSelf="stretch"
          level="1"
          children="Food Journal"
          {...getOverrideProps(overrides, "fDHeader")}
        ></Heading>
        <Divider
          width="unset"
          height="1px"
          shrink="0"
          alignSelf="stretch"
          size="small"
          orientation="horizontal"
          {...getOverrideProps(overrides, "Divider48539689")}
        ></Divider>
        <Flex
          gap="10px"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          position="relative"
          padding="0px 10px 0px 10px"
          {...getOverrideProps(overrides, "fDDateAndSleep")}
        >
          <TextField
            width="480px"
            height="unset"
            label=" Date"
            descriptiveText="log meals on this date"
            shrink="0"
            placeholder="Placeholder"
            size="small"
            isDisabled={false}
            labelHidden={false}
            variation="default"
            {...getOverrideProps(overrides, "fDDate")}
          ></TextField>
          <TextField
            width="480px"
            height="unset"
            label="Sleep:"
            descriptiveText="Hours slept"
            shrink="0"
            placeholder="Placeholder"
            size="small"
            isDisabled={false}
            labelHidden={false}
            variation="default"
            {...getOverrideProps(overrides, "fdSleep")}
          ></TextField>
        </Flex>
        <Flex
          gap="10px"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          overflow="hidden"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "fDBreakfastAndLunch")}
        >
          <Flex
            gap="10px"
            direction="column"
            width="470px"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            overflow="hidden"
            shrink="0"
            position="relative"
            padding="10px 10px 10px 10px"
            {...getOverrideProps(overrides, "fDBreakfast")}
          >
            <Heading
              width="unset"
              height="unset"
              shrink="0"
              level="4"
              children="Breakfast:"
              {...getOverrideProps(overrides, "Heading486110297")}
            ></Heading>
            <TextField
              width="unset"
              height="unset"
              label=" Time:"
              descriptiveText="log meals on this date"
              shrink="0"
              alignSelf="stretch"
              placeholder="Placeholder"
              size="small"
              isDisabled={false}
              labelHidden={false}
              variation="default"
              {...getOverrideProps(overrides, "fDBreakfastTime")}
            ></TextField>
            <TextAreaField
              width="unset"
              height="unset"
              label="What did you eat/drink?"
              shrink="0"
              alignSelf="stretch"
              placeholder="Placeholder"
              size="default"
              isDisabled={false}
              labelHidden={false}
              variation="default"
              {...getOverrideProps(overrides, "fDBreakfastNotes")}
            ></TextAreaField>
            <TextAreaField
              width="unset"
              height="unset"
              label="How did you feel after?"
              shrink="0"
              alignSelf="stretch"
              placeholder="Placeholder"
              size="default"
              isDisabled={false}
              labelHidden={false}
              variation="default"
              {...getOverrideProps(overrides, "fDBreakfastHowIFeltNotes")}
            ></TextAreaField>
          </Flex>
          <Flex
            gap="10px"
            direction="column"
            width="470px"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            overflow="hidden"
            shrink="0"
            position="relative"
            padding="10px 10px 10px 10px"
            {...getOverrideProps(overrides, "fDLunch")}
          >
            <Heading
              width="unset"
              height="unset"
              shrink="0"
              level="4"
              children="Lunch:"
              {...getOverrideProps(overrides, "Heading486110306")}
            ></Heading>
            <TextField
              width="unset"
              height="unset"
              label=" Time:"
              descriptiveText="log meals on this date"
              shrink="0"
              alignSelf="stretch"
              placeholder="Placeholder"
              size="small"
              isDisabled={false}
              labelHidden={false}
              variation="default"
              {...getOverrideProps(overrides, "fDLunchTime")}
            ></TextField>
            <TextAreaField
              width="unset"
              height="unset"
              label="What did you eat/drink?"
              shrink="0"
              alignSelf="stretch"
              placeholder="Placeholder"
              size="default"
              isDisabled={false}
              labelHidden={false}
              variation="default"
              {...getOverrideProps(overrides, "fDLunchNotes")}
            ></TextAreaField>
            <TextAreaField
              width="unset"
              height="unset"
              label="How did you feel after?"
              shrink="0"
              alignSelf="stretch"
              placeholder="Placeholder"
              size="default"
              isDisabled={false}
              labelHidden={false}
              variation="default"
              {...getOverrideProps(overrides, "fDLunchHowIFeltNotes")}
            ></TextAreaField>
          </Flex>
        </Flex>
        <Divider
          width="unset"
          height="1px"
          shrink="0"
          alignSelf="stretch"
          size="small"
          orientation="horizontal"
          {...getOverrideProps(overrides, "Divider486110354")}
        ></Divider>
        <Flex
          gap="10px"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          overflow="hidden"
          shrink="0"
          position="relative"
          padding="10px 10px 10px 10px"
          {...getOverrideProps(overrides, "fDDinnerAndSnacks")}
        >
          <Flex
            gap="10px"
            direction="column"
            width="470px"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            overflow="hidden"
            shrink="0"
            position="relative"
            padding="10px 10px 10px 10px"
            {...getOverrideProps(overrides, "fDDinner")}
          >
            <Heading
              width="unset"
              height="unset"
              shrink="0"
              level="4"
              children="Dinner:"
              {...getOverrideProps(overrides, "Heading486110330")}
            ></Heading>
            <TextField
              width="unset"
              height="unset"
              label=" Time:"
              descriptiveText="log meals on this date"
              shrink="0"
              alignSelf="stretch"
              placeholder="Placeholder"
              size="small"
              isDisabled={false}
              labelHidden={false}
              variation="default"
              {...getOverrideProps(overrides, "fDDinnerTime")}
            ></TextField>
            <TextAreaField
              width="unset"
              height="unset"
              label="What did you eat/drink?"
              shrink="0"
              alignSelf="stretch"
              placeholder="Placeholder"
              size="default"
              isDisabled={false}
              labelHidden={false}
              variation="default"
              {...getOverrideProps(overrides, "fDDinnerNotes")}
            ></TextAreaField>
            <TextAreaField
              width="unset"
              height="unset"
              label="How did you feel after?"
              shrink="0"
              alignSelf="stretch"
              placeholder="Placeholder"
              size="default"
              isDisabled={false}
              labelHidden={false}
              variation="default"
              {...getOverrideProps(overrides, "fDDinnerHowIFeltNotes")}
            ></TextAreaField>
          </Flex>
          <Flex
            gap="10px"
            direction="column"
            width="470px"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            overflow="hidden"
            shrink="0"
            position="relative"
            padding="10px 10px 10px 10px"
            {...getOverrideProps(overrides, "fDSnacks")}
          >
            <Heading
              width="unset"
              height="unset"
              shrink="0"
              level="4"
              children="Snacks:"
              {...getOverrideProps(overrides, "Heading486110359")}
            ></Heading>
            <TextField
              width="unset"
              height="unset"
              label=" Time:"
              descriptiveText="log meals on this date"
              shrink="0"
              alignSelf="stretch"
              placeholder="Placeholder"
              size="small"
              isDisabled={false}
              labelHidden={false}
              variation="default"
              {...getOverrideProps(overrides, "fDSnackTime")}
            ></TextField>
            <TextAreaField
              width="unset"
              height="unset"
              label="What did you eat/drink?"
              shrink="0"
              alignSelf="stretch"
              placeholder="Placeholder"
              size="default"
              isDisabled={false}
              labelHidden={false}
              variation="default"
              {...getOverrideProps(overrides, "fDSnackNotes")}
            ></TextAreaField>
            <TextAreaField
              width="unset"
              height="unset"
              label="How did you feel after?"
              shrink="0"
              alignSelf="stretch"
              placeholder="Placeholder"
              size="default"
              isDisabled={false}
              labelHidden={false}
              variation="default"
              {...getOverrideProps(overrides, "fDSnackHowIFeltNotes")}
            ></TextAreaField>
          </Flex>
        </Flex>
        <Divider
          width="unset"
          height="1px"
          shrink="0"
          alignSelf="stretch"
          size="small"
          orientation="horizontal"
          {...getOverrideProps(overrides, "Divider486110383")}
        ></Divider>
        <Flex
          gap="10px"
          direction="row"
          width="unset"
          height="unset"
          justifyContent="flex-start"
          alignItems="flex-start"
          shrink="0"
          position="relative"
          padding="0px 10px 0px 10px"
          {...getOverrideProps(overrides, "fDWaterAndExercise")}
        >
          <TextField
            width="480px"
            height="unset"
            label="Water:"
            descriptiveText="Log water consumption"
            shrink="0"
            placeholder="Placeholder"
            size="small"
            isDisabled={false}
            labelHidden={false}
            variation="default"
            {...getOverrideProps(overrides, "fDWater")}
          ></TextField>
          <TextField
            width="480px"
            height="unset"
            label="Workout:"
            descriptiveText="Log workouts"
            shrink="0"
            placeholder="Placeholder"
            size="small"
            isDisabled={false}
            labelHidden={false}
            variation="default"
            {...getOverrideProps(overrides, "fdExercise")}
          ></TextField>
        </Flex>
        <Flex
          gap="18px"
          direction="row"
          width="71px"
          height="unset"
          justifyContent="flex-end"
          alignItems="center"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "FooterActions")}
        >
          <Button
            width="unset"
            height="unset"
            justifyContent="flex-end"
            shrink="0"
            size="default"
            isDisabled={false}
            variation="primary"
            children="Save"
            {...getOverrideProps(overrides, "SaveButton")}
          ></Button>
        </Flex>
        <Text
          fontFamily="Inter"
          fontSize="14px"
          fontWeight="400"
          color="rgba(0,0,0,1)"
          lineHeight="21px"
          textAlign="right"
          display="block"
          direction="column"
          justifyContent="unset"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="Added By: H.J"
          {...getOverrideProps(overrides, "Added By: H.J")}
        ></Text>
      </Flex>
    </Flex>
  );
}
